export default __webpack_public_path__ + "static/media/char_head_prem_002.6495634b.png";